export default "__VITE_PUBLIC_ASSET__e15d803f__"